export function updateSignState(data) {
  return {
    type: "UPDATE_SIGN_STATE",
    payload: data,
  };
}

export function clearSignState() {
  return {
    type: "CLEAR_SIGN_STATE",
  };
}

export function addLoginData(data) {
  return {
    type: "ADD_LOGIN_DATA",
    payload: data,
  };
}

export function updateAddressInfo(data) {
  return {
    type: "UPDATE_ADDRESS_INFO",
    payload: data,
  };
}
